module.exports = __webpack_public_path__ + "assets/img/truly-chat-icon.96fecd8d.svg";